import { Event } from '../../../../standard/v1';

export interface WalgreensEvent extends Event {
    WIC: string
}